import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SlaBusinessEscalation } from 'src/app/models/documents.model';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { setRegex } from 'src/app/libs/functions/common.functions';

@Component({
  selector: 'app-business-escalation-input',
  standalone: false,
  templateUrl: './business-escalation-input.component.html',
  styleUrl: './business-escalation-input.component.scss',
})
export class BusinessEscalationInputComponent {
  businessForm!: FormGroup;
  setRegex = setRegex;
  current: number = 2;
  @Input() slaDataInput: SlaBusinessEscalation = {
    operational_name: '',
    operational_job_title: '',
    operational_phone_number: '',
    operational_email: '',
    finance_name: '',
    finance_job_title: '',
    finance_phone_number: '',
    finance_email: '',
    technology_name: '',
    technology_job_title: '',
    technology_phone_number: '',
    technology_email: '',
  };
  @Output() businessData = new EventEmitter<SlaBusinessEscalation>();
  [key: string]: any;
  validOName: boolean = true;
  errMessOName: string = '';
  validFName: boolean = true;
  errMessFName: string = '';
  validTName: boolean = true;
  errMessTName: string = '';

  validTJob: boolean = true;
  errMessTJob: string = '';
  validFJob: boolean = true;
  errMessFJob: string = '';
  validOJob: boolean = true;
  errMessOJob: string = '';

  validONumber: boolean = true;
  errMessONumber: string = '';
  validFNumber: boolean = true;
  errMessFNumber: string = '';
  validTNumber: boolean = true;
  errMessTNumber: string = '';

  validOEmail: boolean = true;
  errMessOEmail: string = '';
  validTEmail: boolean = true;
  errMessTEmail: string = '';
  validFEmail: boolean = true;
  errMessFEmail: string = '';
  serviceType: string = localStorage.getItem('service_type_doc') || '';
  mode: string = localStorage.getItem('mode-sla-input') || '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formValidation: FormValidationService,
    private message: NzMessageService
  ) { }

  ngOnInit() {
    this.initForm();

    if (this.businessForm) {
      this.businessForm.patchValue(this.slaDataInput);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['slaDataInput'] && changes['slaDataInput'].currentValue) {
      const slaData = changes['slaDataInput'].currentValue;

      if (this.businessForm) {
        this.businessForm.patchValue(slaData);
      }
    }
  }

  initForm() {
    this.businessForm = this.fb.group({
      operational_name: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
        ],
      ],
      operational_job_title: [
        '',
        [Validators.required, Validators.maxLength(100)],
      ],
      operational_phone_number: [
        '',
        [Validators.required, Validators.pattern('^[0-9]*\\.?[0-9]*$')],
      ],
      operational_email: ['', [Validators.required, Validators.email]],

      finance_name: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
        ],
      ],
      finance_job_title: ['', [Validators.required, Validators.maxLength(100)]],
      finance_phone_number: [
        '',
        [Validators.required, Validators.pattern('^[0-9]*\\.?[0-9]*$')],
      ],
      finance_email: ['', [Validators.required, Validators.email]],

      technology_name: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
        ],
      ],
      technology_job_title: [
        '',
        [Validators.required, Validators.maxLength(100)],
      ],
      technology_phone_number: [
        '',
        [Validators.required, Validators.pattern('^[0-9]*\\.?[0-9]*$')],
      ],
      technology_email: ['', [Validators.required, Validators.email]],
    });
  }

  setRegexName(event: KeyboardEvent) {
    const regex = /^[a-zA-Z ]+$/g;
    return regex.test(event.key);
  }

  validateInput(event: Event, fieldType: 'OName' | 'FName' | 'TName' | 'OJob' | 'FJob' | 'TJob') {
    const input = event.target as HTMLInputElement;
    const minLength = 3;
    const maxLength = 50;
    const fieldValidKey = `valid${fieldType}`;
    const fieldErrorKey = `errMess${fieldType}`;
    const fieldLabel = fieldType.includes('Name') ? 'Name' : 'Job title';

    if (input.value === '') {
      this[fieldValidKey] = false;
      this[fieldErrorKey] = `${fieldLabel} must be filled in`;
    } else if (input.value.length < minLength) {
      this[fieldValidKey] = false;
      this[fieldErrorKey] = `Minimum ${minLength} characters`;
    } else if (input.value.length > maxLength) {
      this[fieldValidKey] = false;
      this[fieldErrorKey] = `Maximum ${maxLength} characters`;
    } else {
      this[fieldValidKey] = true;
      this[fieldErrorKey] = '';
    }
  }

  preventNonNumeric(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;

    if (
      !/^\d$/.test(event.key) &&
      !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(
        event.key
      )
    ) {
      event.preventDefault();
    }

    if (input.value.length === 0 && event.key !== '8') {
      event.preventDefault();
    }
  }

  validateInputNumber(event: Event, fieldType: 'ONumber' | 'FNumber' | 'TNumber'): void {
    const input = event.target as HTMLInputElement;
    const fieldValidKey = `valid${fieldType}`;
    const fieldErrorKey = `errMess${fieldType}`;

    const result = this.formValidation.validatePhoneNumber(input.value)

    this[fieldValidKey] = result.valid;
    this[fieldErrorKey] = result.message;
  }


  setRegexBName(event: KeyboardEvent) {
    const regex = /^[a-zA-Z ]+$/g;
    return regex.test(event.key);
  }

  validateEmail(event: Event, fieldType: 'OEmail' | 'FEmail' | 'TEmail') {
    const input = event.target as HTMLInputElement;

    const result = this.formValidation.validateEmail(input.value)
    const fieldValidKey = `valid${fieldType}`;
    const fieldErrorKey = `errMess${fieldType}`;

    this[fieldValidKey] = result.valid;
    this[fieldErrorKey] = result.message;
  }

  onBack(): void {
    this.router.navigate(['/document/sla-data-input'], {
      queryParams: { step: 2, mode: this.mode, service_type: this.serviceType },
    });
  }
  onSubmit(): void {
    if (this.businessForm.valid) {
        this.current = 3;
        this.businessData.emit(this.businessForm.value);
        if (this.mode === 'create') {
          this.router.navigate(['/document/sla-data-input'], {
            queryParams: { step: 4, service_type: this.serviceType },
          });
        } else {
          this.router.navigate(['/document/sla-data-input'], {
            queryParams: { step: 4, mode: this.mode, service_type: this.serviceType },
          });
        }
    } else {
      this.message.error('Form is invalid!');
    }
  }

  get isFormInvalid(): boolean {
    return (
      this.businessForm.invalid ||
      this.errMessTEmail !== '' ||
      this.errMessFEmail !== '' ||
      this.errMessOEmail !== '' ||
      this.errMessTName !== '' ||
      this.errMessOName !== '' ||
      this.errMessFName !== '' ||
      this.errMessONumber !== '' ||
      this.errMessFNumber !== '' ||
      this.errMessTNumber !== '' ||
      this.errMessTEmail !== '' ||
      this.errMessOEmail !== '' ||
      this.errMessFEmail !== ''
    );
  }
}
